import WebsiteLayout from "@/layouts/WebsiteLayout.vue";
import PrintLayout from "@/layouts/PrintLayout.vue";
import AdminLayout from "@/layouts/AdminLayout.vue";

const layouts = {
    website: WebsiteLayout,
    admin: AdminLayout,
    print: PrintLayout
};

export const layout = {
    data() {
        return {
            theme: "website",
        };
    },
    created() {
        let theme = this.theme;
        if (!layouts[theme]) {
            theme = "website";
        }
        // console.log(layouts[theme])
        this.$emit("update:layout", layouts[theme]);
    }
};
